<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.uuid"
          :label="$t('profile.setupdefinition.uuid')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.extruderQuantity"
          :label="$t('profile.setupdefinition.extruderquantity')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.tempControler"
          :label="$t('profile.setupdefinition.tempcontroler')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="machineSelectItems"
          v-model="item.machine"
          :items="machineSelectItems"
          :error-messages="machineErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.setupdefinition.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="toolheadSelectItems"
          v-model="item.toolhead"
          :items="toolheadSelectItems"
          :error-messages="toolheadErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.setupdefinition.toolhead')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialsupplySelectItems"
          v-model="item.materialSupply"
          :items="materialsupplySelectItems"
          :error-messages="materialsupplyErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.setupdefinition.materialsupply')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="printingsurfaceSelectItems"
          v-model="item.printingSurface"
          :items="printingsurfaceSelectItems"
          :error-messages="printingsurfaceErrors"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.setupdefinition.printingsurface')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'SetupDefinitionFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.machineGetSelectItems();
    this.toolheadGetSelectItems();
    this.materialsupplyGetSelectItems();
    this.printingsurfaceGetSelectItems();
  },

  computed: {
    ...mapFields('machine', {
      machineSelectItems: 'selectItems'
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems'
    }),
    ...mapFields('materialsupply', {
      materialsupplySelectItems: 'selectItems'
    }),
    ...mapFields('printingsurface', {
      printingsurfaceSelectItems: 'selectItems'
    }),
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      printingsurfaceGetSelectItems: 'printingsurface/fetchSelectItems'
    }),
    ...mapActions({
      toolheadGetSelectItems: 'toolhead/fetchSelectItems'
    }),
    ...mapActions({
      materialsupplyGetSelectItems: 'materialsupply/fetchSelectItems'
    }),

  }
};
</script>
